import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';

var InputInfo = function (_a) {
  var id = _a.id,
    className = _a.className,
    children = _a.children,
    error = _a.error,
    rest = __rest(_a, ["id", "className", "children", "error"]);
  var idPrefix = error ? 'infoError' : 'info';
  var ariaLive = error ? {
    'aria-live': 'assertive',
    role: 'alert'
  } : {};
  return /*#__PURE__*/React__default__default.createElement("span", __assign({
    id: "".concat(idPrefix, "-").concat(id),
    className: className
  }, ariaLive, rest), children);
};
InputInfo.displayName = 'InputInfo';
InputInfo.defaultProps = {
  error: false,
  children: ''
};
var InputInfoChildren = PropTypes__default.string;
InputInfo.propTypes = {
  id: PropTypes__default.string.isRequired,
  className: PropTypes__default.node.isRequired,
  children: InputInfoChildren,
  error: PropTypes__default.bool
};

export { InputInfo, InputInfoChildren, InputInfo as default };
